import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import Swal from "sweetalert2";
import { selectHasPermission } from "../store/slices/authSlice";
import SessionCategoryList from "../pages/SessionCategory/SessionCategoryList";
import {
    fetchSessionCategories,
    deleteSessionCategory,
    clearError,
} from "../store/slices/sessionCategorySlice";

const SessionCategories = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const canManageSessionCategories = useSelector((state) =>
        selectHasPermission(state, "session-categories-manage")
    );
    const canCreateSessionCategories = useSelector((state) =>
        selectHasPermission(state, "session-categories-create")
    );
    const canEditSessionCategories = useSelector((state) =>
        selectHasPermission(state, "session-categories-edit")
    );
    const canDeleteSessionCategories = useSelector((state) =>
        selectHasPermission(state, "session-categories-delete")
    );

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        dispatch(fetchSessionCategories()).finally(() => setIsLoading(false));
    }, [dispatch]);

    const handleAddSessionCategory = () => navigate("/session-categories/add");
    const handleEditSessionCategory = (id) => navigate(`/session-categories/edit/${id}`);
    const handleDeleteSessionCategory = async (id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You want to delete this session category? This might affect session types linked to it.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
        });

        if (result.isConfirmed) {
            try {
                await dispatch(deleteSessionCategory(id)).unwrap();
                Swal.fire("Deleted!", "Session Category has been deleted.", "success");
            } catch (err) {
                Swal.fire("Error!", err.message || "Failed to delete session category.", "error");
            }
        }
    };

    if (!canManageSessionCategories) {
        return (
            <Navigate
                to="/dashboard"
                state={{ error: "You do not have permission to manage session categories." }}
                replace
            />
        );
    }

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                <div className="card">
                    <div className="card-body">
                        {isLoading ? (
                            <div className="d-flex justify-content-center py-5">
                                <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <SessionCategoryList
                                onEditSessionCategory={canEditSessionCategories ? handleEditSessionCategory : null}
                                onDeleteSessionCategory={canDeleteSessionCategories ? handleDeleteSessionCategory : null}
                                onAddSessionCategory={canCreateSessionCategories ? handleAddSessionCategory : null}
                            />
                        )}
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default SessionCategories;
